import { isMobileScreen } from '@apply/ui';
import { ActiveExperienceViewTypeOptions } from '../../../constants/ActiveExperienceViewTypeOptions';
import { ActiveExperienceViewType } from '../../../constants/ActiveExperienceViewType';
import RadioGroup from 'devextreme-react/radio-group';

export interface ExperienceViewRadioGroupProps {
    experienceViewType: ActiveExperienceViewType;
    onValueChanged: (value: ActiveExperienceViewType) => void;
}

export const ExperienceViewRadioGroup: React.FC<ExperienceViewRadioGroupProps> = ({ experienceViewType, onValueChanged }) => {
    const mobileScreen = isMobileScreen();

    return (
        <RadioGroup
            items={ActiveExperienceViewTypeOptions}
            valueExpr='id'
            value={experienceViewType}
            onValueChanged={(event) => onValueChanged(parseInt(event.value))}
            layout='horizontal'
        />
    );
};
